export const INPUT_EVENT_TYPES = {
  input: 'input',
  blur: 'blur',
};
